import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, useParams } from "react-router-dom";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const EmailViewer = () => {
    const { emailId } = useParams();
    const [emailContent, setEmailContent] = useState("Loading...");

    

    useEffect(() => {
        const fetchEmail = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/email/getemail?id=${emailId}`);
                setEmailContent(response.data.emailContent);
            } catch (error) {
                setEmailContent("Error loading email content.");
            }
        };
        fetchEmail();
        
    }, [emailId]);

    return (
        <div style={{margin: "20px"}}>
            <div dangerouslySetInnerHTML={{ __html: emailContent }} />
        </div>
    );
};

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/view-email/:emailId" element={<EmailViewer />} />
            </Routes>
        </Router>
    );
};

export default App;
